import { render } from "./AddGroupMultipleOption.vue?vue&type=template&id=f2efdd42&scoped=true"
import script from "./AddGroupMultipleOption.vue?vue&type=script&lang=js"
export * from "./AddGroupMultipleOption.vue?vue&type=script&lang=js"

import "./AddGroupMultipleOption.vue?vue&type=style&index=0&id=f2efdd42&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2efdd42"]])

export default __exports__